// @ts-check

// Change API url based on environment 
var location = 'prod';
		var envUrl = window.location.href;
		if(envUrl.indexOf('local') > -1) {
			location = 'local';
		}        
		if ((envUrl.indexOf('dev.') > -1) || (envUrl.indexOf('integration') > -1)) {
			location = 'integration';
		}
		if ((envUrl.indexOf('test.') > -1) || (envUrl.indexOf('staging') > -1)) {
			location = 'staging';
		}
        if (envUrl.indexOf('prod.apps.') > -1) {
			location = 'prod-os4';
		}
/**
 * @typedef {'loc'} Location
 */
/**
 * @type {Location}
 */
/**
 * @returns {string}
 */

function getApiUrl() {
    switch (location) {
        case 'prod': return 'https://www.liberty.edu/DonorRecognition/?api';
        case 'prod-os4': return 'https://wt-donorgivingwall-prod.apps.lyn-cre01.liberty.edu/?api';
        case 'integration': return 'https://integration-donorwall.liberty.edu/?api';
        case 'staging': return 'https://staging-donorwall.liberty.edu/?api';
        case 'local': return 'http://local.liberty.edu/donor-wall/?api'; // change back to donor-wall/?api
        default: throw new Error('invalid location');
    }
}

/**
 * @param {string} venue 
 * @returns {string}
 */
function generateResponseBackUrl(venue) {
    switch (location) {
        case 'prod': return `https://prod-donorwall-middleman.liberty.edu/commandBack?queueName=${venue}`;
        case 'prod-os4': return `https://wt-middleman-prod.apps.lyn-cre01.liberty.edu/commandBack?queueName=${venue}`;
        case 'integration': return `https://integration-middleman.liberty.edu/commandBack?queueName=${venue}`;
        case 'staging': return `https://staging-middleman.liberty.edu/commandBack?queueName=${venue}`;
        case 'local': return `http://localhost:8083/commandBack?queueName=${venue}`;
        default: throw new Error('invalid location');
    }
}

/**
 * @param {string} venue 
 * @returns {string}
 */
function generateSocketUrl(venue) {
    switch (location) {
        case 'prod': return `wss://prod-donorwall-middleman.liberty.edu/retrieveCommand?queueName=${venue}`;
        case 'prod-os4': return `wss://wt-middleman-prod.apps.lyn-cre01.liberty.edu/retrieveCommand?queueName=${venue}`;
        case 'integration': return `wss://integration-middleman.liberty.edu/retrieveCommand?queueName=${venue}`;
        case 'staging': return `wss://staging-middleman.liberty.edu/retrieveCommand?queueName=${venue}`;
        case 'local': return `ws://localhost:8083/retrieveCommand?queueName=${venue}`;
        default: throw new Error('invalid location');
    }
}

export { getApiUrl, generateResponseBackUrl, generateSocketUrl };